import { DeliveryModel } from '@audibene/ta.utils-opportunity'

const teleaudiologyDeliveryModels = new Set<DeliveryModel>([DeliveryModel.TELEAUDIOLOGY])

const networkDeliveryModels = new Set<DeliveryModel>([DeliveryModel.NETWORK, DeliveryModel.NETWORK_HOME_DELIVERY])

export { networkDeliveryModels, teleaudiologyDeliveryModels }
